import React from 'react'
import PropTypes from 'prop-types'

import useStyles from './form-label.style'

const Label = (props) => {
  const classes = useStyles(props)

  return (<label className={classes.label}>{props.children}</label>)
}

Label.defaultProps = {
  children: null
}

Label.propTypes = {
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.string])
}

export default Label

